import React from 'react';
import Joyride from 'react-joyride';
import './tour-controller.scss';
import { useTourController } from './hooks/use-tour-controller';
import { TourToolip } from './components';

export const TourController: React.FC = () => {
  const {
    currentTooltipIndex,
    holdTourRun,
    isTourActive,
    joyrideRef,
    setHoldTourRun,
    steps,
  } = useTourController();

  return (
    <Joyride
      ref={joyrideRef}
      key={currentTooltipIndex}
      run={isTourActive && !holdTourRun}
      stepIndex={0}
      tooltipComponent={TourToolip}
      continuous
      disableScrolling
      debug
      spotlightClicks={false}
      disableOverlayClose={false}
      disableScrollParentFix={true}
      steps={steps}
      callback={(data) => {
        const { action, index, type, status } = data;

        if (status === 'running') {
          if (index !== 0) {
            return;
          }
        }

        if (type === 'step:after') {
          if (action === 'next') {
            // dispatch(updateActiveTourTooltipIndex(index + 1));
          } else if (action === 'prev' && index > 0) {
            // dispatch(updateActiveTourTooltipIndex(index - 1));
          } else if (action === 'close' && status === 'running') {
            setHoldTourRun(true);
          }
        } else if (type === 'tour:end') {
          if (status === 'finished') {
            // dispatch(updateActiveTourTooltipIndex(0)); // Reset
          }
        }
      }}
      floaterProps={{
        disableAnimation: true,
        disableFlip: true,
      }}
      styles={{
        options: {
          zIndex: 100000,
        },
        spotlightLegacy: {
          backgroundColor: 'transparent',
          borderRadius: 4,
        },
        spotlight: {
          borderRadius: 4,
        },
        tooltipContainer: {
          position: 'absolute',
        },
      }}
    />
  );
};
